{
	"name": "circutikz-designer",
	"version": "0.7.5",
	"private": "true",
	"description": "An interactive, visual, online editor for creating electrical circuit diagrams for LaTeX/CircuiTikZ with ease.",
	"license": "GPL-3.0-only",
	"author": "Manuel Kirzinger",
	"contributors": [
		{
			"name": "Philipp Wiedemann",
			"email": "jan.p.wiedemann@fau.de"
		},
		{
			"name": "Christof Pfannenmüller",
			"email": "christof.pfannenmueller@fau.de"
		}
	],
	"source": "src/pages/index.html",
	"main": "src/scripts/main.js",
	"targets": {
		"main": false
	},
	"scripts": {
		"build": "parcel build --public-url ./",
		"update": "npx npm-check-updates -u",
		"prepack": "npm run build",
		"start": "parcel serve --lazy",
		"postversion": "git push && git push origin tag $(git describe --tags --abbrev=0)",
		"standalone": "electron-forge start",
		"electron": "npm run build && electron .",
		"package": "electron-forge package",
		"make": "electron-forge make"
	},
	"browserslist": "> 0.5%, last 2 versions, not dead",
	"dependencies": {
		"@prettier/plugin-xml": "^3.4.2",
		"@svgdotjs/svg.draggable.js": "^3.0.6",
		"@svgdotjs/svg.js": "^3.2.4",
		"@svgdotjs/svg.panzoom.js": "^2.1.2",
		"bootstrap": "^5.3.7",
		"electron-squirrel-startup": "^1.0.1",
		"file-saver": "^2.0.5",
		"hotkeys-js": "^3.13.15",
		"prettier": "^3.6.2",
		"text-to-svg": "^3.1.5"
	},
	"devDependencies": {
		"@electron-forge/cli": "^7.8.2",
		"@electron-forge/maker-deb": "^7.8.2",
		"@electron-forge/maker-rpm": "^7.8.2",
		"@electron-forge/maker-squirrel": "^7.8.2",
		"@electron-forge/maker-wix": "^7.8.2",
		"@electron-forge/maker-zip": "^7.8.2",
		"@electron-forge/plugin-auto-unpack-natives": "^7.8.2",
		"@electron-forge/plugin-fuses": "^7.8.2",
		"@electron/fuses": "^2.0.0",
		"@parcel/config-default": "^2.15.4",
		"@parcel/packager-raw-url": "^2.15.4",
		"@parcel/plugin": "^2.15.4",
		"@parcel/transformer-css": "^2.15.4",
		"@parcel/transformer-html": "^2.15.4",
		"@parcel/transformer-js": "^2.15.4",
		"@parcel/transformer-posthtml": "^2.15.4",
		"@parcel/transformer-sass": "^2.15.4",
		"@parcel/transformer-svg": "^2.15.4",
		"@parcel/transformer-typescript-tsc": "^2.15.4",
		"@parcel/transformer-webmanifest": "^2.15.4",
		"@parcel/transformer-xml": "^2.15.4",
		"@types/bootstrap": "^5.2.10",
		"@types/file-saver": "^2.0.7",
		"@types/text-to-svg": "^3.1.4",
		"buffer": "^6.0.3",
		"electron": "^37.2.5",
		"parcel": "^2.15.4",
		"path-browserify": "^1.0.1",
		"posthtml-include": "^2.0.1",
		"process": "^0.11.10",
		"sass": "^1.89.2",
		"typescript": "^5.9.2"
	}
}
